import napStyles from './../nap.json'

export default {
  name: '4',
  type: 'Label',
  color: napStyles.colors.PrimaryBlack,
  inverseColor: napStyles.colors.PrimaryWhite
}
